<script lang="ts" setup>
import { useAlertsStore } from '@/stores/alerts';
import { useUserStore } from '@/stores/user';
import { storeToRefs } from 'pinia';
import { ref } from 'vue';
import { useRouter } from 'vue-router';
import { getAvatar } from '../../utils';

const router = useRouter();
const { messages } = storeToRefs(useAlertsStore());
const { removeMessage } = useAlertsStore();
const userStore = useUserStore();

let limitPosition = ref(500);
let scrolled = ref(false);
let lastPosition = ref(0);

function goFavorite(advertNumber?: number) {
    if(!advertNumber) {
        return;
    }

    router.push({ name: 'profile', params: { advert: advertNumber } })
}
</script>

<template src="./alerts.html"></template>

<style lang="scss">
@import './alerts.scss';
</style>
